import styled from 'styled-components'

const AddCommentWrap = styled.button`
  all: unset;
`

export { AddCommentWrap }
